import { gql } from '../../../../../types/__codegen__/sanity';

export const GET_PERK_IDS = gql(`
  query GetPerkIds {
    allMemberPerk {
      _id
      _updatedAt
      identifier {
        current
      }
      release {
        ...ReleaseFields
      }
    }
  }
`);
